var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardBackgroundDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 126,
    viewBox: "0 0 221 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24V102C0 115.255 10.7452 126 24 126H197.004C210.259 126 221.004 115.255 221.004 102V77.4264C221.004 63.6205 208.965 52.9025 195.252 54.5C181.539 56.0975 169.5 45.3795 169.5 31.5736V24C169.5 10.7452 158.755 0 145.5 0H24C10.7452 0 0 10.7452 0 24Z",
    fill: "#232323",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBackgroundDark);
export default __webpack_public_path__ + "static/media/card_background_dark.6e6eb10bb519dd57cc697fc1085ec8e1.svg";
export { ForwardRef as ReactComponent };